import { Component } from 'react';
/*
import React, { Component } from 'react';
import Butt from './Butt';
import { Apify } from '../Apify';
import API from '../API';
import { R } from '../routes';
import { T } from '../traks';
*/


/*
class SelectPortfolio extends Component {
	constructor(props) {
		super(props);
		this.state = {
			adding_to_portfolio: null,
			add_quantity: 1
		};
	}

	render() {
		if (this.state.adding_to_portfolio === null) {
			return this.props.portfolios.map((portfolio) => {
				const click = () => {
					this.setState({adding_to_portfolio: portfolio});
				};
				return <Butt key={portfolio.Id} onClick={click} className="ad_btn_sm"><T>Add to {portfolio.Name}</T></Butt>;
			});
		} else {
			const portfolio = this.state.adding_to_portfolio;
			const execute = () => {
				const args = {
					portfolio_id: portfolio.Id,
					quantity: this.state.add_quantity,
					exchange: this.props.exchange,
					ticker: this.props.ticker
				};
				API.post("/a/add_stock_to_portfolio", args, (response) => {
					R.go("/portfolio/:id", {id: portfolio.Id});
				});
			};
			const cancel = () => {
				this.props.cancel();
			};
			const simple_change = (e) => {
				this.setState({
					[e.target.name]: e.target.value
				});
			};
			return (
				<div>
					Add
					<input
						value={this.state.add_quantity}
						type="number"
						name="add_quantity"
						onChange={simple_change}
					/>
					to {portfolio.Name}
					<Butt onClick={execute} className="ad_btn_sm"><T>Execute</T></Butt>
					<Butt onClick={cancel} className="ad_btn_sm"><T>Cancel</T></Butt>
				</div>
			);
		}
	}

SelectPortfolio = Apify("/a/non_game_portfolios")
	.with_response_prop("portfolios")
	.wrap(SelectPortfolio);
*/

class AddToPortfolio extends Component {
	constructor(props) {
		super(props);
		this.state = { clicked: false };
	}

	render() {
		return null;
		/*
		if (!this.state.clicked) {
			const click = () => {
				this.setState({clicked: true});
			};
			return <Butt onClick={click} className="ad_btn_sm"><T>Add to portfolio</T></Butt>;
		} else {
			const cancel = () => {
				this.setState({clicked: false});
			};
			return <SelectPortfolio exchange={this.props.exchange} ticker={this.props.ticker} cancel={cancel}/>;
		}
		*/
	}
}

export default AddToPortfolio;



// WEBPACK FOOTER //
// ./src/c/AddToPortfolio.js